import React, { FunctionComponent } from 'react'

import { PlaylistMatchesProps } from './props'
import { Container, Title, MatchedGenres } from './styles'

const Component: FunctionComponent<PlaylistMatchesProps> = ({
  matchedPlaylists,
}) => {
  const genresRow = () => {
    let result = ''
    matchedPlaylists.forEach((el, id) => {
      result += el
      if (id !== matchedPlaylists.length - 1) {
        result += ', '
      }
      if (result.length > 80) {
        result = `${result.substring(0, 80)} ...`
      }
    })
    return result
  }

  return (
    <Container>
      <Title>Playlist matches</Title>
      <MatchedGenres>{genresRow()}</MatchedGenres>
    </Container>
  )
}

export const PlaylistMatches = React.memo(Component)
